import EventFolderListActions from 'flux/actions/EventFolderListActions';
import EventDocListActions from 'flux/actions/EventDocListActions';
import RouteActions from 'flux/actions/RouteActions';

export const getFSRefObjectId = (item) =>
  item.getIn(['reference', 'object', '_id']);
export const getFSRefObject = (item) => item.getIn(['reference', 'object']);
export const isShowFSObject = (item) =>
  item.getIn(['reference', 'kind']) === 'Show';
export const isDocFSObject = (item) =>
  item.getIn(['reference', 'kind']) === 'EventDoc';
export const isDirectory = (item) => item.get('isDirectory');

export const getFSObjectClickHandler = (item, teamId, eventId) => {
  if (isDirectory(item))
    return () => {
      EventFolderListActions.setFolder(item);
    };

  let refObjectId = getFSRefObjectId(item);

  if (isShowFSObject(item)) {
    let showId = refObjectId,
      displayType = item.getIn(['reference', 'object', 'displayType']);
    return () =>
      RouteActions.goToShowDisplayType(
        { teamId, eventId, showId },
        displayType,
      );
  }

  if (isDocFSObject(item)) {
    return () =>
      EventDocListActions.downloadDocIntoWindow(
        teamId,
        eventId,
        getFSRefObjectId(item),
        false,
      );
  }

  return () => {
    //noop
  };
};

export const isTypeOfShow = (type) =>
  ['show', 'list', 'schedule'].indexOf(type) >= 0;

export const getFSObjectType = (item) => {
  if (isDirectory(item)) return 'folder';

  if (isShowFSObject(item))
    return item.getIn(['reference', 'object', 'displayType']);

  return 'doc';
};

export const getFSObjectName = (item) => {
  if (isDirectory(item)) return item.get('name');

  return (
    item.getIn(['reference', 'object', 'title']) ||
    item.getIn(['reference', 'object', 'name'])
  );
};

export const getFSObjectDesc = (item) => {
  if (isDirectory(item)) return item.get('description');
  if (isDocFSObject(item)) return null;

  return item.getIn(['reference', 'object', 'description']);
};
